import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Sender} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Sender, {
        'uploadProps': this.getUploadProps(),
        'ev-messageSend': this.onMessageSend,
        'ev-uploadProgress': this.onUploadProgress,
        'ev-uploadSuccess': this.onUploadSuccess,
        'ev-uploadError': this.onUploadError,
        'ev-$model:value': function($v) {
            $this.set('value', $v);
        },
        'value': $this.get('value'),
        'ev-$model:attachments': function($v) {
            $this.set('attachments', $v);
        },
        'attachments': $this.get('attachments')
    });
};